import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'luxonDate',
})
export class LuxonDatePipe implements PipeTransform {
  transform(date: string | Date, format?: string): string | null {
    const locale = navigator.language || 'en';
    let luxonDate: DateTime;

    if (typeof date === 'string') {
      luxonDate = DateTime.fromISO(date).setLocale(locale);
    } else if (date instanceof Date) {
      luxonDate = DateTime.fromJSDate(date).setLocale(locale);
    } else {
      return null;
    }

    if (!luxonDate.isValid) {
      return null;
    }

    const defaultFormat = 'dd/LL/yyyy HH:mm';

    if (format) {
      if (format === 'humanize') {
        return luxonDate.toRelative();
      }
      if (format === 'date-short' || format === 'shortDate') {
        return luxonDate.toFormat('dd/LL/yyyy');
      }
      return luxonDate.toFormat(format);
    }

    return luxonDate.toFormat(defaultFormat);
  }
}
